import { render, staticRenderFns } from "./MetadadosCampoDinamicoLista.vue?vue&type=template&id=440d579e"
import script from "./MetadadosCampoDinamicoLista.vue?vue&type=script&lang=js"
export * from "./MetadadosCampoDinamicoLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports